import { motion, useInView, useAnimation } from "framer-motion";
import mobile from "../../assets/images/mobile.png";
import database from "../../assets/images/database.png";
import web from "../../assets/images/webdesign.png";
import uxui from "../../assets/images/uxui.png";
import developer from "../../assets/images/dev.gif";

export default function AboutSkill() {
  return (
    <motion.div
      className=" w-full items-center m-auto flex flex-col space-y-10 h-full"
      transition={{ duration: 300 }}
    >
      {/**description */}
      <div className="grid rounded-md md:grid-cols-2 h-auto gap-2  bg-[#978b72]  text-[#FFFFFFFF] text-[12px] mb:text-[14px]">
        <div className="flex p-4 items-center">
          <p className="text-[13px] ">
            I am an adaptable and driven Software Developer with a strong
            foundation in full-stack development. An individual who is actively seeking opportunities to
            bring impactful solutions to real world challenges.
            <br />
            <br />
            Beyond formal education, I am proactively pursuing personal
            development opportunities including hackathons and personal projects,
            mentoring up coming developers, Learning from experinced developers.
            <br />
            <br />
            I am open to opportunities for collaboration, internship and learnership
          </p>
        </div>
        <div className="flex items-center justify-center">
          <img src={developer} alt="" className="w-[60%]  object-contain" />
        </div>
      </div>
      {/**this div overlaps the top */}
      <div className="space-y-4 w-full">
        <div className="flex gap-5 flex-row items-center">
          <h1 className="text-[#2e2d69] md:text-xl font-bold">What I do</h1>
          <div className="flex-1 h-[2px] rounded-full w-full bg-black" />
        </div>

        <div className="w-full gap-4 grid md:grid-cols-2 ">
          {/**Mobile */}
          <div className="grid gap-6 pt-5 text-white">
            <div className="flex items-center bg-[#978b72] rounded-md p-3  gap-3">
              <img className="h-20 shadow-sm" src={mobile} />
              <div className=" overflow-hidden p-2 gap-2 flex flex-col">
                <h1 className="font-bold text-sm"> Mobile Apps</h1>
                <p className="text-[13px]">
                  I develop mobile application for android using kotlin.
                </p>
              </div>
            </div>
            {/**Web */}
            <div className="flex items-center bg-[#978b72] rounded-md p-3 gap-3">
              <img className="h-20 shadow-sm" src={web} />
              <div className=" p-2 gap-2 flex flex-col">
                <h1 className="font-bold text-sm"> Web apps</h1>
                <p className="text-[13px]">
                  I develop web application with Javacript and react.
                </p>
              </div>
            </div>
          </div>
          {/**Web */}
          <div className="grid gap-6 md:pt-5 text-white">
            <div className="flex items-center bg-[#978b72] rounded-md p-3 gap-3">
              <img className="h-20 shadow-sm" src={uxui} />
              <div className="p-2 gap-2 flex flex-col">
                <h1 className="font-bold text-sm"> UX/UI</h1>
                <p className="text-[13px]">
                  high-quality design made at a professional level.
                </p>
              </div>
            </div>
            {/**Web */}
            <div className="flex items-center bg-[#978b72] rounded-md p-2 gap-3">
              <img
                className="h-20 object-contain shrink-0 shadow-sm"
                src={database}
              />
              <div className=" min-h-0 p-2 gap-2 flex flex-col">
                <h1 className="font-bold text-sm"> Database</h1>
                <p className="text-[13px]">
                  Backend services designed for scalability and security
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}
